import React, { useState } from "react";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";

import "./stylesAddNewIpPopup.css";
import { X } from "react-feather";
import { API_ROUTES } from "../../../api/ApiRoutes";
import { CloseOutlined } from "@ant-design/icons";
import { message } from "antd";

function AddNewIpPopup({ onClosePressed, getAdmins, selectedAdmin }) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [ipAddress, setIpAddress] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const buttonDisabled = ipAddress.length <= 0 ? true : false;

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    const params = {
      ip_address: ipAddress,
      admin_id: selectedAdmin.admin_id,
      action: "add",
    };

    try {
      await PrivateAdminPanelInstance?.post(API_ROUTES?.WHITELIST_IP, params);
      message.success("IP added successfully!");

      setIpAddress("");
      await getAdmins();
    } catch (error) {
      console.log("Error adding IP:", error);
      message.error("Error adding IP. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClosePressed = () => {
    onClosePressed();
    setIpAddress("");
  };

  return (
    <div className="add-new-ip-popup">
      <div className="add-new-ip-panel">
        <div className="modal-header">
          <div className="modal-header-title">
            <h2 className="modal-title">
              Add new IP to: {selectedAdmin.admin_name}
            </h2>
          </div>
          <CloseOutlined onClick={handleClosePressed} className="close-icon" />
        </div>

        <div className="divider" />

        <form onSubmit={handleSubmit}>
          <div className="ip-address-input-container">
            <label htmlFor="ipAddress">IP Address:</label>
            <input
              type="text"
              id="ipAddress"
              value={ipAddress}
              placeholder="Enter IP Address"
              onChange={(e) => setIpAddress(e.target.value)}
              required
            />
          </div>

          <div className="modal-footer">
            <button className="cancel-button" onClick={handleClosePressed}>
              Close
            </button>
            <button
              type="submit"
              disabled={buttonDisabled}
              className={`submit-button ${
                buttonDisabled || isSubmitting ? "disabled" : null
              }`}
            >
              {isSubmitting ? "Adding IP..." : "Add IP"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddNewIpPopup;
